import React from "react";
import PropTypes from "prop-types";
import { CustomTooltipStyle } from "./CustomTooltip.styles";

const CustomTooltip = ({ children }) => {
  const classes = CustomTooltipStyle();

  return (
    <div className={classes.container}>
      <div className={classes.triangle} />
      <div className={classes.tooltip}>
        <div className={classes.content}>{children}</div>
      </div>
    </div>
  );
};

CustomTooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(CustomTooltip);
